import React, { useEffect, useRef, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useDispatch, useSelector } from "react-redux";

//Components
import Layout from "../../../../Layout/Layout";
import CustomerConstants from "../../../../common/CustomerConstants";

import DeleteMaterialV5 from "./DeleteMaterialV5";
import CatalogProductDetailModalV5 from "../Common/CatalogModal/CatalogProductDetailModalV5";

import MaterialHRModalV5 from "./MaterialHBModalV5";

import { SearchField } from "../../../../Components/formElements/SearchField";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import ShowUploadImageV5 from "./ShowUploadImageV5";
// import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MultiColumnFilter from "../../../../Components/MultiColumnFilter/MultiColumnFilter";
import {
  addMaterial,
  getMaterialList,
} from "../../../../redux/feature/customer_app/customerSlice";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import { useReactToPrint } from "react-to-print";
import Barcode from "react-barcode";
import { TruckElectric } from "lucide-react";
import { Button, Modal, Form } from "react-bootstrap";

// import ItemService from "../../../../services/supplier_appCommonService";

// import { formatDate } from "../../../../common/Validations";

const MaterialV5 = () => {
  localStorage.setItem("menu", "Master");
  localStorage.setItem("submenu", "Material Master");

  const dispatch = useDispatch();

  let materialData = useSelector((state) => state?.customer?.material?.data); // User Details from Store
  // console.log(">>materialData",materialData)
  let materialTable = useSelector(
    (state) => state?.customer?.material?.pagination,
  );
  // console.log(">>materialTable",materialTable)

  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");
  const [getNewPerPage, setNewPerPage] = useState(10);

  const [modalDeleteMaterial, setModalDeleteMaterial] = useState(false);
  const [modalShowAddProduct, setModalShowAddProduct] = useState(null);
  const [modalShowDetailProduct, setModalShowDetailProduct] = useState(false);

  const [isCardVisible2, setCardVisible2] = useState(true);

  const [getData, setData] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  // eslint-disable-next-line
  const [getFileViewData, setFileViewData] = useState(null);
  // const target = useRef(null);

  //print barcode
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printRowData, setPrintRowData] = useState(null); // Selected row data
  const [printType, setPrintType] = useState(""); // "BARCODE" or "QR"
  const [printQuantity, setPrintQuantity] = useState(1); // Default 1 copy

  const barcodeRef = useRef();

  const openPrintModal = (row, type) => {
    setPrintRowData(row);
    setPrintType(type); // 'BARCODE' or 'QR'
    setPrintQuantity(1); // Reset to 1 every time
    setShowPrintModal(true);
  };

  const handlePrintBarcode = useReactToPrint({
    contentRef: barcodeRef,
    documentTitle: "Barcode_Print",
    pageStyle: `@page { size: 30mm 50mm; margin: 0mm; }`, // portrait label
    onAfterPrint: () => setShowPrintModal(false),
  });

  const handleFinalPrint = () => {
    handlePrintBarcode();
  };

  const columns = [
    {
      name: "Material",
      id: "materialImage",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <div
          className="flex justify-center items-center cursor-pointer"
          // onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
        >
          <div className="w-75">
            <ShowUploadImageV5 fileid={row?.materialImage} />
          </div>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "View",
      id: "view",
      selector: (row) => row.productName || "--",
      cell: (row) => (
        <button
          className="btn btn-table d-flex"
          onClick={() => showAddProduct("DETAILS", row.documentNumber, row)}
        >
          <i class="bi bi-eye mx-2"></i>
          View
        </button>
      ),
      sortable: true,
      width: "140px",
    },

    {
      name: "Barcode",
      cell: (row) => (
        <>
          {row.materialGroup === "SERVICES" ? (
            <>
              <button
                className="btn btn-sm d-flex align-items-center gap-1"
                style={{ backgroundColor: "#98d8d8", fontWeight: "bold" }}
                // OLD: onClick={() => triggerPrint(row)}
                // NEW:
                onClick={() => openPrintModal(row, "BARCODE")}
                title="Print Barcode"
              >
                <i className="bi bi-upc-scan"></i>
                Print
              </button>
            </>
          ) : (
            <>--</>
          )}
        </>
      ),
      width: "120px",
    },
    {
      name: "Code",
      id: "materialCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.productName || "--",
      cell: (row) => (
        // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

        <div className="flex justify-center items-center">
          <div className="ms-2">
            <p className="m-0 p-0 pt-1 fw-bold">{row?.materialCode} </p>

            <p className="m-0 p-0 pt-1 fw-bold text-success">
              {row.materialDescription}{" "}
            </p>
          </div>
        </div>
      ),
      sortable: true,
      width: "300px",
    },
    {
      name: "Active/InActive",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },
    {
      name: "Company Code",
      id: "companyCode",
      // id1:"materialDescription",
      // dropDown: true,
      selector: (row) => row.companyCode || "--",
      cell: (row) => (
        <div className="ms-2">
          <p className="m-0 p-0 pt-1 fw-medium">{row?.companyCode} </p>
        </div>
      ),
      sortable: true,
      width: "140px",
    },
    // {
    //   name: "Discription",
    //   selector: (row) => row.productName || "--",
    //   cell: (row) => (
    //     // <div className="d-flex justify-content-center w-50 align-items-center cursor-pointer">

    //     <div className="flex justify-center items-center">
    //       <div className="ms-2">
    //         <p className="m-0 p-0 pt-1 fw-bold text-primary">{row.materialDescription} </p>
    //         {/* <p className="m-0 p-0 pt-1">{row?.materialCode} </p> */}
    //       </div>
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "250px",
    // },
    /*   {
      name: "AVG",
      selector: (row) => row.average || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.average} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    }, */
    {
      name: "Unit",
      selector: (row) => row.unit || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.unit} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },
    {
      name: "Qty",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.purchaseQuantity || ""} </p>
        </div>
      ),
      sortable: true,
      width: "80px",
    },

    {
      name: "Vendor Rate (Unit Price)",
      selector: (row) => row.unitPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">
            {row.orderPriceUnit ?? row.unitPrice}{" "}
          </p>
        </div>
      ),
      sortable: true,
      width: "160px",
    },
    {
      name: "M R P",
      selector: (row) => row.mrPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.mrPrice} </p>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Category",
      id: "materialGroup",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.materialGroup} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Material Sub Cat",
      id: "materialSubCategory",
      selector: (row) => row.materialSubCategory || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.materialSubCategory} </p>
        </div>
      ),
      width: "160px",
    },
    {
      name: "HSN Code",
      id: "hsnCode",
      selector: (row) => row.hsnCode || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.hsnCode} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Rent Per Day",
      id: "rentPerDayPrice",
      selector: (row) => row.rentPerDayPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rentPerDayPrice} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Rent 7 Days",
      id: "rent7DaysPrice",
      selector: (row) => row.rent7DaysPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rent7DaysPrice} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Rent 15 Days",
      id: "rent15DaysPrice",
      selector: (row) => row.rent15DaysPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rent15DaysPrice} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Rent 30 Days",
      id: "rent30DaysPrice",
      selector: (row) => row.rent30DaysPrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.rent30DaysPrice} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Sale Price",
      id: "salePrice",
      selector: (row) => row.salePrice || "--",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1">{row.salePrice} </p>
        </div>
      ),
      width: "130px",
    },
    {
      name: "Attachments",
      selector: (row) => row.materialAttachments,
      cell: (row) => (
        <div
          style={{ width: "100%" }}
          className="d-flex justify-content-center cursor-pointer"
          // onClick={()=>showViewInvoice(row)}
          // onClick={() => handlePrintWithData(row)}
        >
          <img
            src="assets/img/newIcons/attached-file.png"
            alt="attachments"
            style={{ width: "25px" }}
            className="mt-1"
          />
        </div>
      ),
      sortable: true,
      width: "130px",
    },

    // {
    //   name: "Details",
    //   cell: (row) => (
    //     <div className="d-flex align-items-center gap-2">
    //       <OverlayTrigger
    //         placement="bottom"
    //         delay={{ show: 150, hide: 200 }}
    //         overlay={
    //           <Tooltip
    //             id={`tooltip-${row.documentNumber}`}
    //             className="custom-tooltip"
    //             target={target.current}
    //           >
    //             <div style={{ textAlign: "left" }}>
    //               {/* <strong>Location:</strong> {row.location} <br /> */}

    //               <strong>Remarks:</strong>
    //               {row?.remarks || "--"}
    //               <br />
    //               <strong>Created By:</strong>
    //               {row?.createdBy || "--"}
    //               <br />
    //               <strong>Created Date:</strong>
    //               {row?.createdDate || "--"}
    //               <br />
    //               <strong>Updated Date:</strong>
    //               {row?.updatedDate || "--"}
    //               <br />
    //             </div>
    //           </Tooltip>
    //         }
    //       >
    //         <button
    //           className="btn btn-light p-1 border-0"
    //           title="View Details"
    //           // onClick={() => handleViewDetails(row)}
    //         >
    //           <i className="bi bi-eye fs-5 text-primary"></i>
    //         </button>
    //       </OverlayTrigger>
    //     </div>
    //   ),
    //   width: "100px",
    // },

    {
      name: "Edit",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button
            title="Edit"
            className="btn d-flex align-items-center w-100"
            // onClick={DeleteMaterial}
            onClick={() => showAddProduct("EDIT", row.documentNumber, row)}
          >
            <i class="bi bi-pencil-square pe-2"></i>{" "}
            {/* <sapn className="m-0 p-0 pt-1">Edit </sapn> */}
          </button>
        </div>
      ),
      sortable: true,
      width: "120px",
    },
    {
      name: "Delete",
      selector: (row) => row.purchaseType || "--",
      cell: (row) => (
        <div>
          <button onClick={() => deleteMaterial(row)}>
            {/* <i class="bi bi-trash3"></i> */}
            <i className="bi bi-trash text-danger fs-4" />
          </button>
        </div>
      ),
      sortable: true,
      width: "200px",
    },
  ];

  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  // const handleViewFile = (fileAttachmentId) => {
  //   setFileViewData(fileAttachmentId);
  //   setShowFileViewModal(true);
  // };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  const deleteMaterial = (data) => {
    setModalDeleteMaterial(true);
    setData(data);
    dispatch(addMaterial(data.documentNumber));
  };
  const [getPropsData, setPropsData] = useState();
  const showAddProduct = (mode, materialnumber, data) => {
    setModalShowAddProduct(mode);
    setPropsData(data);

    if (mode === "EDIT") {
      dispatch(addMaterial(materialnumber));
    } else if (mode === "DETAILS") {
      dispatch(addMaterial(materialnumber));
    } else {
      dispatch(addMaterial(""));
    }
  };

  const hideModal = () => {
    setModalDeleteMaterial(false);
    setModalShowAddProduct(null);
    setModalShowDetailProduct(false);
  };

  useEffect(() => {
    let obj = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 10,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
    };
    dispatch(getMaterialList(obj));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (page) => {
    let obj = {
      queryName: "getMaterilMasterList",
      page: page,
      per_page: getNewPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getMaterialList(obj));
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {
      queryName: "getMaterilMasterList",
      page: page,
      per_page: newPerPage,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    setNewPerPage(newPerPage);
    dispatch(getMaterialList(obj));
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 10,
      rowFilter: activeFilters.length > 0 ? { $and: activeFilters } : {},
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getMaterialList(obj));
  };
  // const [data, setDataFilter] = useState();
  const [filterShow, setFilterShow] = useState(false);
  const [activeFilters, setActiveFilters] = useState([]);

  const handleFilterData = async (filters) => {
    setActiveFilters(filters);
    const obj = {
      queryName: "getMaterilMasterList",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: filters.length > 0 ? { $and: filters } : {},
    };

    dispatch(getMaterialList(obj));
  };

  const columnsForFilter = columns
    .filter((col) => col.id || col.selectorKey)
    .map((col) => ({
      name: col.name,
      selectorKey: col.id || col.selectorKey,
      dropDown: col.dropDown || false,
      range: col.range || false,
      month: col.month || false,
    }));
  //barcode
  const PrintableBarcode = React.forwardRef(({ data, quantity }, ref) => {
    if (!data) return null;

    const items = Array.from({ length: quantity > 0 ? quantity : 1 });

    return (
      <>
        <style>{`
        @media print {
          @page {
            size: 30mm 50mm;
            margin: 0;
          }
          body * { visibility: hidden; }
          #barcode-print-area, #barcode-print-area * { visibility: visible; }
          #barcode-print-area {
            position: absolute;
            left: 2mm;
            top: 2mm;
            width: 30mm;
          }
          .barcode-label {
            width: 30mm;
            height: 50mm;
            page-break-after: always;
            overflow: hidden;
            box-sizing: border-box;
          }
        }
      `}</style>

        <div id="barcode-print-area" ref={ref}>
          {items.map((_, index) => (            
            <div
              key={index}
              className="barcode-label"
              style={{
                width: "113px",
                height: "189px",
                borderRadius: "3px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                margin: "6px",
                marginBottom: "8px",
                overflow: "hidden", //  overflow hidden to ensure content doesn't spill out
                boxSizing: "border-box",
                padding: "4px",
                gap: "2px",
                position: "relative", //  add this
              }}
            >
              {/*  Barcode wrapper — strictly contained */}
              <div
                style={{
                  width: "85px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <div
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    width: "155px",
                    height: "80px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Barcode
                    value={data?.materialGroup || "N/A"}
                    width={1.2}
                    height={60}
                    format="CODE128"
                    displayValue={true}
                    fontSize={15}
                    fontWeight={30}
                    margin={1}
                  />
                </div>
              </div>
              {/*  Material name — right side */}
              <div
                style={{
                  width: "20px",
                  height: "160px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  flexShrink: 0,
                }}
              >
                <span
                  style={{
                    transform: "rotate(90deg)",
                    transformOrigin: "center center",
                    whiteSpace: "nowrap",
                    fontSize: "6px",
                    fontWeight: "bold",
                    width: "155px",
                    textAlign: "center",
                    display: "block",
                  }}
                >
                  {/* {data.materialCode} | {data.materialDescription} */}
                </span>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  });

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle"> Material Master</h2>
                <p className="subText">Material</p>
              </Col>
              <Col
                xs={12}
                md={3}
                lg={3}
                className="d-flex justify-content-end mt-3"
              >
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={12} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i class="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <div style={{ display: "none" }}>
              <PrintableBarcode
                ref={barcodeRef}
                data={printRowData}
                quantity={printQuantity}
              />
            </div>
            {filterShow && (
              <MultiColumnFilter
                columns={columnsForFilter}
                data={getData}
                onFilter={handleFilterData}
                onCancel={() => setFilterShow(false)}
              />
            )}
            {/* material */}
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible2
                            ? "bi-chevron-down"
                            : "bi-chevron-right"
                        }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MD</span>
                    </Col>
                    <Col xs={6} md={4} lg={4}>
                      <span className="headerTitle">Material List</span>
                      <span className="subHeaderTitle">Material</span>
                    </Col>

                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      {/*     <Col xs={3} md={3} lg={3} className="">
                        <button className="btnTable d-flex justify-content-center">
                          <p className="m-0 me-2">
                            {" "}
                            <span className="mr-2">
                              <i class="bi bi-upload"></i>
                            </span>
                            Upload
                          </p>
                        </button>
                      </Col> */}
                      <Col xs={3} md={3} lg={3} className="">
                        <button
                          className="btnTable d-flex justify-content-center"
                          onClick={() => showAddProduct("CREATE")}
                        >
                          <p className="m-0 me-2">Material Creation</p>
                          {/* <i class="bi bi-plus-square"></i> */}
                        </button>
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible2 ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          keyField="materialCode" 
                          title=""
                          columns={columns}
                          data={materialData}
                          // progressPending={purchaseOrderData?.status}
                          paginationRowsPerPageOptions={
                            CustomerConstants.ROW_PER_PAGE
                          }
                          pagination
                          paginationServer
                          paginationTotalRows={materialTable?.total || ""}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          // onSelectedRowsChange={handleRowSelected}
                          selectableRows
                        />
                      </Col>
                    </Row>
                    <Modal
                      show={showPrintModal}
                      onHide={() => setShowPrintModal(false)}
                      centered
                    >
                      <Modal.Header closeButton>
                        <Modal.Title>
                          Print {printType === "QR" ? "QR Code" : "Barcode"}
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Form.Group>
                          <Form.Label>Enter Quantity (Copies)</Form.Label>
                          <Form.Control
                            type="number"
                            min="1"
                            value={printQuantity}
                            onChange={(e) =>
                              setPrintQuantity(parseInt(e.target.value) || 1)
                            }
                            disabled={TruckElectric}
                            autoFocus
                          />
                        </Form.Group>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          onClick={() => setShowPrintModal(false)}
                        >
                          Close
                        </Button>
                        <Button variant="primary" onClick={handleFinalPrint}>
                          Print Copies
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
      <DeleteMaterialV5
        show={modalDeleteMaterial}
        onHide={() => hideModal()}
        data={getData}
        // dropdownData={getAccountGroup}
      />
      <MaterialHRModalV5
        show={modalShowAddProduct}
        onHide={() => hideModal()}
        data={getPropsData}
      />
      <CatalogProductDetailModalV5
        show={modalShowDetailProduct}
        onHide={() => hideModal()}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default MaterialV5;
